import axiosClient from "./ApiInstance";
import { APIS } from "./ApiEndpoints";
import toast from "react-hot-toast";
import { Select2Data } from "./common";


// Helper function to create FormData from object
const createFormData = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
      if (data[key] instanceof File) {
        formData.append(key, data[key]);
      } else if (Array.isArray(data[key])) {
        // For Laravel, arrays should be sent as key[] or key[0], key[1], etc.
        data[key].forEach((item, index) => {
          if (item instanceof File) {
            formData.append(`${key}[${index}]`, item);
          } else {
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else {
        formData.append(key, data[key]);
      }
    }
  });
  return formData;
};

// Register API - Initial registration
export const ContactUsForm = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.ContactUS, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Contact Us Form failed");
    throw error;
  }
};
export const registerGymMember = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymMember.register, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Registration failed");
    throw error;
  }
};
export const registerGymOwner = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.register, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Registration failed");
    throw error;
  }
};

// Step 1 API
export const submitStep1 = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step1, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Step 1 completed successfully");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 1 submission failed");
    throw error;
  }
};

// Step 2 API
export const submitStep2 = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step2, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Step 2 completed successfully");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 2 submission failed");
    throw error;
  }
};

// Step 3 API
export const submitStep3 = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step3, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Step 3 completed successfully");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 3 submission failed");
    throw error;
  }
};

// Step 4 API
export const submitStep4 = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step4, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Step 4 completed successfully");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 4 submission failed");
    throw error;
  }
};

// Step 5 API
export const submitStep5 = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step5, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Step 5 completed successfully");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 5 submission failed");
    throw error;
  }
};

// Step 6 API
export const submitStep6 = async (data) => {
  try {
    // const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step6, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Step 6 completed successfully");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 6 submission failed");
    throw error;
  }
};

// Step 7 API
export const submitStep7 = async (data) => {
  try {
    const formData = createFormData(data);
    const response = await axiosClient.post(APIS.gymOwner.step7, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Registration completed successfully!");
    return response.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Step 7 submission failed");
    throw error;
  }
};

// Get Progress API - Load saved data
export const getRegistrationProgress = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.getProgress);
    return response.data;
  } catch (error) {
    console.error("Error fetching registration progress:", error);
    throw error;
  }
};

// Get Amenities API
export const getAmenities = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.amenities);
    return response.data;
  } catch (error) {
    console.error("Error fetching amenities:", error);
    throw error;
  }
};

// Get Facilities API
export const getFacilities = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.facilities);
    return response.data;
  } catch (error) {
    console.error("Error fetching facilities:", error);
    throw error;
  }
};

// Get Key Services API   
export const getKeyServices = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.keyServices);
    return response.data;
  } catch (error) {
    console.error("Error fetching key services:", error);
    throw error;
  }
};

// Get Business Constitution API
export const getBusinessConstitution = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.businessConstitution);
    return response.data;
  } catch (error) {
    console.error("Error fetching business constitution:", error);
    throw error;
  }
};

// Get Business Designation API
export const getBusinessDesignation = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.businessDesignation);
    return await Select2Data(response?.data?.data, "designation_id");
  } catch (error) {
    console.error("Error fetching business designation:", error);
    throw error;
  }
};

// Get App Setup API
export const getAppSetup = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.appSetup);
    return response.data;
  } catch (error) {
    console.error("Error fetching app setup:", error);
    throw error;
  }
};

// Get About Us API
export const getAboutUs = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.aboutUs);
    return response.data;
  } catch (error) {
    console.error("Error fetching about us:", error);
    throw error;
  }
};

// Get States API
export const getStates = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.states);
    return response.data;
  } catch (error) {
    console.error("Error fetching states:", error);
    throw error;
  }
};

// Get Cities API
export const getCities = async (stateId) => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.cities + `/${stateId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cities:", error);
    throw error;
  }
};

// Get Goals API
export const getGoals = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.goals);
    return response.data;
  } catch (error) {
    console.error("Error fetching goals:", error);
    throw error;
  }
};

// Get Levels API
export const getLevels = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.levels);
    return response.data;
  } catch (error) {
    console.error("Error fetching goals:", error);
    throw error;
  }
};
export const getSocialLinks = async () => {
  try {
    const response = await axiosClient.get(APIS.gymOwner.socialLink);
    return response.data;
  } catch (error) {
    console.error("Error fetching goals:", error);
    throw error;
  }
};


// Get getTerms API
export const getTerms = async (type) => {
  try {
    const response = await axiosClient.get(`${APIS.gymOwner.termsCondition}?type=${type}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching goals:", error);
    throw error;
  }
};


// Get getPrivacy API
export const getPrivacy = async (type) => {
  try {
    const response = await axiosClient.get(`${APIS.gymOwner.privacyPolicy}?type=${type}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching goals:", error);
    throw error;
  }
};


